import { render, staticRenderFns } from "./AdvertiserManageIndex.vue?vue&type=template&id=7151b6f2&"
import script from "./AdvertiserManageIndex.vue?vue&type=script&lang=js&"
export * from "./AdvertiserManageIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports